import { Component, ElementRef, HostListener, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { DatePipe } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import {
  NgbdSortableHeader,
  SortEvent,
} from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import {
  AppointmentStatusList,
  WorkOrderStatus,
} from '../../../business-entities/appointmentStatus-model';
import * as Enums from '../../../../../../Autofacets-Core/src/app/utils/enums';
import { BrandViewModel } from '../../../business-entities/brand-view-model';
import { UserDealersModel } from '../../../business-entities/dealer-details.model';
import { DealerViewModel } from '../../../business-entities/dealer-view-model';
import { PagerData } from '../../../business-entities/PagerData';
import { CustomerWaitingListViewModel } from '../../../business-entities/customer-waiting-list-view-model';
import {CustomerWaitingRequestModel  } from '../../../business-entities/customer-waiting-request-model';
import { CustomerListViewModel } from '../../../business-entities/customer-list-view-model';
import { AppointmentService } from '../../../business-services/appointment.service';
import { BrandService } from '../../../business-services/brand.service';
import { DealerBusinessService } from '../../../business-services/dealer.service';
import jsPDF from 'jspdf';
import { CustomerWaitingListService } from '../../../business-services/customer-waiting-list.service';
import autoTable from 'jspdf-autotable';
import { ExcelService } from 'projects/Autofacets-Core/src/app/common-services/export-excel.service';
import { AppointmentList, AppointmentStatusRequestModel } from '../../../business-entities/appointmentList-model';
import { SaveAdvanceSearchFilterModel } from '../../../business-entities/save-advance-search-filter';
import { AppointmentStatus } from '../../../../../../Autofacets-Core/src/app/utils/enums';
import { Filter } from '../../../business-entities/Filter';
import { SelectListItemViewModel } from '../../../business-entities/select-list-item-view-model';
import { DealerServiceViewModel } from '../../../business-entities/dealer-service-view-model';
import { CustomPaggerService } from 'projects/Autofacets-Core/src/app/common-services/custom-pagger.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { AppointmentComponent } from '../../appointment/appointment.component';
import { AppointmentDetail } from '../../../business-entities/appointmentDetail-model';
import { MultiStackPopupService } from '../../../services/multi-stack-popup.service';
import { AdminCommonService } from '../../../services/admin-common.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';
import { UserDataService } from 'src/app/DataServices/user-data.service';


@Component({
  selector: 'app-customer-waiting',
  templateUrl: './customer-waiting.component.html',
})
export class CustomerWaitingComponent implements OnInit {
  @ViewChild(AppointmentComponent) AppointmentInput: AppointmentComponent;
  searchTerm: string;
  isAdvanceSearch: boolean = false;
  dealerServiceList: DealerServiceViewModel[];
  appointmentStatusList: AppointmentStatusList[] = [];
  workOrderStatusList: WorkOrderStatus[];
  workOrderStatus: WorkOrderStatus[] = [];
  appointmentstatusList: AppointmentStatus[];
  bookingDate: any[] = [];
  createdDate: any[] = [];
  selectedDealer: any;
  selectedStatus: number;
  isTodayViewOn: boolean=true;
  paginationSub: Subscription;
  isWeekViewOn: boolean=false;
  selectedDealerId: string = '';
  DealerName: string = null;
  filter: Filter = new Filter();
  filterItems: any[];
  licensePlateClass: string;
  customerWaitingList: any = [];
  dealers: DealerViewModel[] = [];
  dataRows: any[] = [];
  brandList: BrandViewModel[];
  pager: any = {};
  customerlist: any;
  customerListExcel: any;
  totalCount: number = 0;
  pagerData: PagerData = {
    page: 1,
    pagerSize: Constant.GridPagerSize,
  };
  saveSearchFilter: SaveAdvanceSearchFilterModel = {
    filterName: null,
    moduleId: Enums.ModuleNames.Appointment,
    saveSearchArray: []
  };
  appointmentStatusRequestModel: AppointmentStatusRequestModel = {
    bookingDate: null,
    createdDate: null,
    dealerId: null,
    serviceAdvisorId:null,
    mechanicId:null,
    appointmentStatusId: null,
    workOrderStatusId: null,
    customerName: null,
    languageCode: null,
    licensePlate: null,
    mobileNumber: null,
    woNumber: null
  };
  dealerId: string = null;
  dealerSelected: string = '';
  isAdvanceDealerSearch: boolean = false;
  statusId: number = Enums.AppointmentStatus.Cancelled;
  status: AppointmentStatus[] = [];
  selecteddealerId:string;
  customerWaitingResponse: CustomerWaitingListViewModel[];
  waitingList: CustomerWaitingListViewModel[] = [];
  WorkOrderStatusId : number = 0;
  statusSelected: string = '';
  statusList: Array<SelectListItemViewModel>;
  appointmentList: AppointmentList[] = [];
  pagedItems: any[];
  workorderstatuslistRequest:CustomerWaitingRequestModel = {
    sortColumn: '',
    sortDirection: '',
    StartRecordNumber: 0,
    DealerId: '',
    BookingDate: '',
    PageSize: 0,
    LanguageCode: '',
    AppointmentStatusId: 0,
    WorkOrderStatusId: 0,
    SearchTerm: '',
    IsForDocuments: true,
    UserId: '',
    CreatedDate: new Date()
  };
  appointmentDay: string = '';
  isRentalCar: boolean = false;
  myDateRangePickerOptions: Partial<BsDaterangepickerConfig> = Object.assign({},{
    containerClass: 'theme-dark-blue',
    displayMonths:1,
    showWeekNumbers:false,
    rangeInputFormat: 'DD/MM/YYYY',
    customTodayClass: 'custom-today-class'
  });
  selectedCreatedDate:any[]= [];
  selectedBookingDate:any[]= [];

CustomerWaiting = {
  sortColumn: '',
  sortDirection: '',
  StartRecordNumber: 0,
  DealerId: '',
  BookingDate: null,
  createdDate:null,
  PageSize: 0,
  LanguageCode: '',
  AppointmentStatusId: null,
  WorkOrderStatusId: 0,
  SearchTerm: '',
  IsForDocuments: true,
  UserId: '',
  customerName:'',
  dealerName:''
}
advancesearchlist:any=[];
weekViewDate:any;
todayViewDate: any;
contactDetails: AppointmentDetail;
debounceTimer :any;
dataList :any =[]


  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

  constructor(
    private globalSetting: GlobalSetting,
    private brandService: BrandService,
    private spinner: NgxSpinnerService,
    private cookieservice: CookieService,
    public pService: CustomPaggerService,
    private appointmentService: AppointmentService,
    public dealerBusinessService: DealerBusinessService,
    private customerWaitingservice: CustomerWaitingListService,
    private excelService: ExcelService,
    private datePipe: DatePipe,
    private multiStackPopupService: MultiStackPopupService,
    private _eref: ElementRef,
    private admincommonService : AdminCommonService,
    private translate: TranslateService,
    private toaster: ToastrService,
    private userService: UserDataService
  ) { }

  ngOnInit(): void {
    this.selecteddealerId = this.userService.currentUserValue.defaultDealerId;
    this.CustomerWaiting.DealerId = this.selecteddealerId;
    this.customerWaitingservice.workorderstatuslistRequest.DealerId = this.selecteddealerId;
    this.licensePlateClass = this.globalSetting.getGlobalLicencePlate();
    this.getUserDealers();
    this.getBrands().then(() => {
      let language = this.cookieservice.get('userSelectedLanguage');
      this.GetAllWorkOrderStatus(language);
    });
    if (this.customerWaitingservice.filterTypeId == 1) {
      this.loadTodayView();
    } else if (this.customerWaitingservice.filterTypeId == 2) {
      this.loadWeekView();
    } else {
      this.loadTodayView();
    }
  }

  public get documentTypes(): typeof Enums.DocumentsType {
    return Enums.DocumentsType;
  }
  async getUserDealers() {
    await this.dealerBusinessService
      .getUserDealersDropdown()
      .then((response) => {
        this.dealers = this.mapDealerListToDealers(response.userDealersModel);
        if(this.dealers.length===1){
          this.selecteddealerId = this.dealers[0].dealerId;
        }
      });
  }
  @HostListener('document:click', ['$event'])
  onSearchBoxClose(event) {
    if (event) {
      if (!this._eref.nativeElement.getElementsByClassName('advanced-search-box')[0]?.contains(event.target)) {
        this.isAdvanceSearch = false;
      }
    }
  }
  public getBrands(): Promise<void> {
    return new Promise((resolve, _reject) => {
      this.brandService.getBrand().then((res) => {
        if (res) {
          this.brandList = res;
        }
        resolve();
      });
    });
  }

  getBrandImage(key: any) {
    return this.brandList?.filter(
      (x) => x.brandCode.toUpperCase() === key.toUpperCase()
    )[0];
  }

  refresh(){
    this.CustomerWaiting.WorkOrderStatusId = null;
    this.waitingList=[];
    this.loadTodayView();
  }
  onDealerChange(dealerId:string)
  {
    if (dealerId == this.CustomerWaiting.DealerId) {
      this.customerWaitingservice.workorderstatuslistRequest.DealerId = dealerId;
    } else {
      this.CustomerWaiting.DealerId = dealerId;
    }
    this.customerWaitingservice.workorderstatuslistRequest.StartRecordNumber = 0;
    this.waitingList = [];
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 3000);
    this.getCustomerWaitingList();
  }
  resetPagerData(pageData: any) {
    this.pager = pageData.pager;
    this.pagedItems = pageData.pagedItems;
    pageData.recordSize = this.totalCount;
  }

  mapdealer(array: UserDealersModel[]) {
    let supperArray = [];
    if (array && array.length > 0) {
      array.forEach(element=>{ 
        let single = Object();
        single.value = element.dealerId;
        single.text = element.dealerName;
        supperArray.push(single);
      })
    }
    return supperArray;
  }

  mapDealerListToDealers(array: UserDealersModel[]) {
    let supperArray = [];
    if (array && array.length > 0) {
      array.forEach(element=>{ 
        let single = Object();
        single.dealerId = element.dealerId;
        single.name = element.dealerName;
        supperArray.push(single);
      })
    }
    return supperArray;
  }



  async setPage(pagerData: PagerData) {
    if (
      pagerData == null ||
      pagerData === undefined ||
      pagerData.page < 1 ||
      pagerData.page > this.pager.totalPages
    ) {
      return;
    }
    this.pagerData.page = pagerData.page;
    this.pagerData.pagerSize = pagerData.pagerSize;
  }

  onSearch() {
    this.isAdvanceSearch = true;
  }

  onQuickSerch()
  {
    this.CustomerWaiting.SearchTerm = this.searchTerm;
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 3000);
    this.getCustomerWaitingList()
  }


  onStatusChange(status:any) {
    if (status == this.CustomerWaiting.WorkOrderStatusId) {
      this.customerWaitingservice.workorderstatuslistRequest.WorkOrderStatusId = Enums.WOStatus.All;
    } else {
      this.CustomerWaiting.WorkOrderStatusId = status;
    }
    this.customerWaitingservice.workorderstatuslistRequest.StartRecordNumber = 0;
    this.waitingList = [];
    this.spinner.show();
    this.getCustomerWaitingList();
    this.spinner.hide();
  }


  async onSort({ column, direction }: SortEvent) {
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.CustomerWaiting.sortColumn = column;
    this.CustomerWaiting.sortDirection = direction;
    this.CustomerWaiting.StartRecordNumber = 0;
    this.waitingList = [];
    this.spinner.show();
    this.getCustomerWaitingList();
  }


  onClickChangeView(isWeek: boolean) {
    if (isWeek) {
      this.loadWeekView();
    } else {
      this.loadTodayView();
    }
  }

  loadTodayView() {
    this.isTodayViewOn = true;
    this.isWeekViewOn = false;
    let todays_date = new Date();
    this.weekViewDate = this.datePipe.transform(todays_date, 'dd/MM/yyyy') + ' - ' + this.datePipe.transform(todays_date, 'dd/MM/yyyy');
    this.bookingDate=[];
    this.bookingDate.push(todays_date);
    this.bookingDate.push(todays_date);

    this.todayViewDate = this.datePipe.transform(new Date(), 'dd/MM/yyyy') + ' - ' + this.datePipe.transform(new Date(), 'dd/MM/yyyy');
    this.selectedBookingDate = this.bookingDate;
    this.CustomerWaiting.StartRecordNumber = 0;
    this.customerWaitingResponse = [];
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 3000);
    this.getCustomerWaitingList();
  }

  loadWeekView() {
    this.isTodayViewOn = false;
    this.isWeekViewOn = true;
   const {bookingDate} = this.admincommonService.getWeekViewDatesNew(1);
    this.bookingDate = {...bookingDate};
    this.selectedBookingDate = this.bookingDate;
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 3000);
    this.getCustomerWaitingList();
  }

  onReset() {
    this.CustomerWaiting.AppointmentStatusId = null;
    this.CustomerWaiting.WorkOrderStatusId = null;
    this.selectedBookingDate = [];
    this.selectedCreatedDate = [];
  }

  onClose() {
    this.onReset();
    this.isAdvanceSearch = false;
  }


  AdvanceSearchSubmit() {
  this.getCustomerWaitingList();
  this.isAdvanceSearch = false;
  }

  GetAllWorkOrderStatus(languageCode, fromIntialize: boolean = false) {
    this.spinner.show();
    this.appointmentStatusRequestModel.appointmentStatusId = this.appointmentService.appointmentRequestModel.appointmentStatusId;
    this.appointmentStatusRequestModel.workOrderStatusId = this.appointmentService.appointmentRequestModel.workOrderStatusId;
    this.appointmentStatusRequestModel.dealerId = this.appointmentService.appointmentRequestModel.dealerId;
    this.appointmentStatusRequestModel.languageCode = languageCode;
    this.appointmentStatusRequestModel.licensePlate = this.appointmentService.appointmentRequestModel.licensePlate;
    this.appointmentStatusRequestModel.woNumber = this.appointmentService.appointmentRequestModel.woNumber;
    this.appointmentStatusRequestModel.customerName = this.appointmentService.appointmentRequestModel.customerName;
    this.appointmentStatusRequestModel.mobileNumber = this.appointmentService.appointmentRequestModel.mobileNumber;
    if (fromIntialize) {
      this.appointmentStatusRequestModel.bookingDate = this.appointmentService.appointmentRequestModel.bookingDate;
    }
    else {
      let bookingDateFormatted= this.getFormattedDate(this.bookingDate);    
      let createdDateFormatted= this.getFormattedDate(this.createdDate);
      this.appointmentStatusRequestModel.bookingDate = bookingDateFormatted;
      this.appointmentStatusRequestModel.createdDate = createdDateFormatted;
    }

    this.appointmentService.GetAllWorkOrderStatus(this.appointmentStatusRequestModel).then(data => {
      this.workOrderStatusList = data.responseObject.workOrderStatusList;
      this.appointmentstatusList = data.responseObject.appointmentStatusList;
    })
    setTimeout(() => {
      this.spinner.hide();
    }, 3000);
  }

   getCustomerWaitingList() {    
    let selectedBookingDateFormatted= this.getFormattedDate(this.selectedBookingDate);   
    let selectedCreatedDateFormatted= this.getFormattedDate(this.selectedCreatedDate);
    this.spinner.show();
        let customerWaitingRequest=this.CustomerWaiting;
          customerWaitingRequest.BookingDate=selectedBookingDateFormatted;
          customerWaitingRequest.createdDate=selectedCreatedDateFormatted;  
          this.customerWaitingservice.getCustomerWaitingList(customerWaitingRequest).then(
          (res) => {
            if (res == null) {
              //this is intentional;
            }
            else {
              this.customerWaitingResponse = res;
            }
            setTimeout(() => {
              this.spinner.hide();
            }, 2000);
            this.spinner.hide();
          })
          .catch(() => {
            this.spinner.hide();
          });
  }


  onClickPress(woDetail: any){
    this.debounceFunction(()=>this.ViewAppointment(woDetail),500);
  }

  debounceFunction(func,delay){
    window.clearTimeout(this.debounceTimer);
    this.debounceTimer = window.setTimeout(func, delay);
  }

  async ViewAppointment(woDetail: any)
  {
    this.multiStackPopupService.OpenAppointment(woDetail.id);
  }

  // Export functionality

  public async exportAsXLSX() {
    await this.exportData();
    if (this.dataList.length === 0) {
      return;
    }
    this.spinner.show();
    const excelData = this.mapDataForExport();
    this.spinner.hide();
    this.excelService.exportAsExcelFile(excelData, `${this.translate.instant('lblCustomerWaiting')}`);
  }

  public async exportAsPDF() {
    await this.exportData();
    if (this.dataList.length === 0) {
      return;
    }
    this.spinner.show();
    const pdfData = this.mapDataForExport();
    const doc = new jsPDF('portrait');
    autoTable(doc, {
      head: [this.getHeadersForExport()],
      body: pdfData.map(row => Object.values(row)),
      margin: { top: 3, left: 3, right: 3, bottom: 3 },
      styles: { fontSize: 8 },
      columnStyles: {
        0: { cellWidth: 15 },
        1: { cellWidth: 29 },
        2: { cellWidth: 25 },
        3: { cellWidth: 30 },
        4: { cellWidth: 40 },
        5: { cellWidth: 35 },
        6: { cellWidth: 30 }
      }
    });
    doc.save(`${this.translate.instant('lblCustomerWaiting')}.pdf`);
    this.spinner.hide();
  }

  private async exportData(): Promise<void> {
    this.spinner.show();
    this.CustomerWaiting.IsForDocuments = true;
    await this.customerWaitingservice.getCustomerWaitingList(this.CustomerWaiting).then((res) => {
      if (!res || res.length === 0 || res.errorCount > 0) {
        this.toaster.error(this.translate.instant('lblDataNotAvailable'));
        this.dataList = [];
        return;
      }
      this.dataList = res;
    }).finally(() => {
      this.CustomerWaiting.IsForDocuments = false;
      this.spinner.hide();
    });
  }

  private mapDataForExport(): any[] {
    return this.dataList.map((item, index) => ({
      [this.translate.instant('lblNo')]: index + 1,
      [this.translate.instant('lblWoStatus')]: item.workOrderStatus,
      [this.translate.instant('lblRegNumber')]: item.licensePlate,
      [this.translate.instant('lblWoNo')]: item.workOrderNo,
      [this.translate.instant('lblCustomer')]: item.customerName,
      [this.translate.instant('lblMobile')]: item.mobileNo ? '+' + item.mobileCode + ' ' + item.mobileNo : '',
      [this.translate.instant('lblAppointmentDate')]: item.bookedDate
    }));
  }

  private getHeadersForExport(): string[] {
    return [
      this.translate.instant('lblNo'),
      this.translate.instant('lblWoStatus'),
      this.translate.instant('lblRegNumber'),
      this.translate.instant('lblWoNo'),
      this.translate.instant('lblCustomer'),
      this.translate.instant('lblMobile'),
      this.translate.instant('lblAppointmentDate')
    ];
  }
  getFormattedDate(dateRangeArray: any[]){
    let formattedDate: string= "";
    if(dateRangeArray.length != 0){
      let beginDate= this.datePipe.transform(dateRangeArray[0], 'dd/MM/yyyy');
      let lastDate= this.datePipe.transform(dateRangeArray[1], 'dd/MM/yyyy');
      formattedDate= beginDate + ' - ' + lastDate;
    }
    return formattedDate;
  }
}
